'use client';

import { ProductAccessories } from '@eliadmin/core/src/components/product/detail/product-accesories';
import { ProductAccessoriesVariants } from '@eliadmin/core/src/components/product/detail/product-accessories-variants/product-accessories-variants';
import { ProductGifts } from '@eliadmin/core/src/components/product/detail/product-gifts';
import { ProductPackages } from '@eliadmin/core/src/components/product/detail/product-packages';
import { ProductServices } from '@eliadmin/core/src/components/product/detail/product-services';

/**
 * Accessory variants, packages, gifts, services and recommended accessories – placed between the
 * variants and the price. Every block renders nothing without its data; the wrapper then collapses
 * (`empty:hidden`) so the buy box gap does not grow.
 */
export function ProductOffers() {
  return (
    <div className="flex flex-col gap-4 empty:hidden" data-section="product-offers">
      <ProductAccessoriesVariants />
      <ProductPackages />
      <ProductGifts />
      <ProductServices />
      <ProductAccessories />
    </div>
  );
}
